import { useCreateEntityElement } from 'client/context/CreateEntityContext'
import { getChildrenEntities } from 'client/reducers/pageReducer'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useIsHiddenMenu } from 'src/shared/entities/website-header/hooks/use-is-hidden-menu'
import {
  WebsiteHeaderButtonLoginWrapper,
  WebsiteHeaderButtonRegistrationWrapper,
  WebsiteHeaderButtonWrapper,
  WebsiteHeaderLanguageSwitcherWrapper,
  WebsiteHeaderLogoWrapper,
  WebsiteHeaderMenuWrapper,
  WebsiteHeaderRawHtmlWrapper,
  WebsiteHeaderTextWrapper,
  WebsiteHeaderTwitterButtonWrapper,
} from 'src/shared/entities/website-header/ui'

export interface WebsiteHeaderChildrenEntitiesProps {
  childIds?: string[]
}

export const WebsiteHeaderChildrenEntities = ({
  childIds,
}: WebsiteHeaderChildrenEntitiesProps) => {
  const { createEntityElement } = useCreateEntityElement()
  const entities = useSelector(
    //@ts-expect-error @TODO ts migration is needed
    state => getChildrenEntities(state.page.present, childIds),
    shallowEqual,
  )

  const isHiddenMenu = useIsHiddenMenu(entities)

  //@ts-expect-error @TODO ts migration is needed
  return entities.map(entity => {
    switch (entity.type) {
      case EntityTypeEnum.WebsiteLogo:
        return (
          <WebsiteHeaderLogoWrapper key={entity.id}>
            {createEntityElement(entity)}
          </WebsiteHeaderLogoWrapper>
        )
      case EntityTypeEnum.Menu:
        return (
          <WebsiteHeaderMenuWrapper isHidden={isHiddenMenu} key={entity.id}>
            {!isHiddenMenu && createEntityElement(entity)}
          </WebsiteHeaderMenuWrapper>
        )
      case EntityTypeEnum.Text:
        return (
          <WebsiteHeaderTextWrapper key={entity.id}>
            {createEntityElement(entity)}
          </WebsiteHeaderTextWrapper>
        )
      case EntityTypeEnum.RawHtml:
        return (
          <WebsiteHeaderRawHtmlWrapper key={entity.id}>
            {createEntityElement(entity)}
          </WebsiteHeaderRawHtmlWrapper>
        )
      case EntityTypeEnum.TwitterTweetButton:
        return (
          <WebsiteHeaderTwitterButtonWrapper key={entity.id}>
            {createEntityElement(entity)}
          </WebsiteHeaderTwitterButtonWrapper>
        )
      case EntityTypeEnum.WebsiteButton:
        return (
          <WebsiteHeaderButtonWrapper key={entity.id}>
            {createEntityElement(entity)}
          </WebsiteHeaderButtonWrapper>
        )
      case EntityTypeEnum.LoginButton:
        return (
          <WebsiteHeaderButtonLoginWrapper key={entity.id}>
            {createEntityElement(entity)}
          </WebsiteHeaderButtonLoginWrapper>
        )
      case EntityTypeEnum.RegistrationButton:
        return (
          <WebsiteHeaderButtonRegistrationWrapper key={entity.id}>
            {createEntityElement(entity)}
          </WebsiteHeaderButtonRegistrationWrapper>
        )
      case EntityTypeEnum.WebsiteLanguageSwitcher:
        return (
          <WebsiteHeaderLanguageSwitcherWrapper key={entity.id}>
            {createEntityElement(entity)}
          </WebsiteHeaderLanguageSwitcherWrapper>
        )

      default:
        return <div key={entity.id}>{createEntityElement(entity)}</div>
    }
  })
}
